import classNames from 'classnames';
import * as React from 'react';

import {
  Icon,
  IconComponentType,
  IconWrapperProps,
} from 'bones/design-system/components/icons/Icon';

const ICON_SIZE_BY_LINK_SIZE: Record<
  LinkProps['size'],
  IconWrapperProps['size']
> = {
  md: 'md',
  sm: 'sm',
};

export type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  'data-testid'?: never;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  leftIcon?: IconComponentType;
  rightIcon?: IconComponentType;
  size: 'md' | 'sm';
  testId?: string;
};

export const Link: React.VFC<LinkProps> = ({
  children,
  className,
  disabled,
  error,
  leftIcon,
  rightIcon,
  size,
  testId,
  ...props
}) => (
  <a
    className={classNames(className, 'vb-link', `vb-link-size--${size}`, {
      'vb-link-state--disabled': disabled,
      'vb-link-state--error': error,
    })}
    data-testid={testId}
    tabIndex={disabled || error ? -1 : 0}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {leftIcon ? (
      <Icon IconComponent={leftIcon} size={ICON_SIZE_BY_LINK_SIZE[size]} />
    ) : null}
    {children}
    {rightIcon ? (
      <Icon IconComponent={rightIcon} size={ICON_SIZE_BY_LINK_SIZE[size]} />
    ) : null}
  </a>
);
